module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(!_vm.showSuccess) ? _c('submit', {
    on: {
      "success": _vm.success
    }
  }) : _c('success'), _vm._v(" "), _c('alert', {
    attrs: {
      "showModal": _vm.showAlert
    },
    on: {
      "update:showModal": function($event) {
        _vm.showAlert = $event
      }
    }
  }, [_vm._v(_vm._s(_vm.alertMessage))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a26bd7b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/sendPoints/index.vue
// module id = 905
// module chunks = 2